<template>
  <el-select
    filterable
    remote
    v-model="userBusinessInvoiceId"
    :placeholder="placeholder"
    @change="onChangeSelect"
    :remote-method="searchInvoices"
    :loading="loading"
    no-data-text="Sin resultados"
    loading-text="Buscando..."
    style="width: 100%"
  >
    <el-option
      v-for="invoice in invoices"
      :key="invoice.id"
      :label="invoice.number_invoice"
      :value="invoice.id"
    >
      <span style="font-weight: 500;">{{ invoice.number_invoice }}</span>
      <span
        v-if="invoice.client && invoice.client.name"
        style="color: #909399; font-size: 12px; margin-left: 8px;"
      >
        {{ invoice.client.name }}
      </span>
    </el-option>
  </el-select>
</template>

<script>
import invoiceService from "../sales/pages/invoices/services/invoiceService";

export default {
  name: "SelectInvoiceComponent",
  props: {
    placeholder: { default: "Buscar factura..." },
    setUserBusinessInvoiceId: { default: null }
  },
  data() {
    return {
      loading: false,
      loadingFull: false,
      invoices: [],
      userBusinessInvoiceId: this.setUserBusinessInvoiceId
    };
  },
  watch: {
    setUserBusinessInvoiceId(v) {
      this.userBusinessInvoiceId = v;
    }
  },
  methods: {
    // Búsqueda flexible: acepta texto parcial, sin restricción de status por defecto
    searchInvoices(query) {
      clearTimeout(this._searchTimer);
      this._searchTimer = setTimeout(() => this.fetchInvoices(query), 280);
    },

    async fetchInvoices(query = "") {
      this.loading = true;
      try {
        const params = { status: "success" };
        if (query && query.trim()) params.search = query.trim();
        const response = await invoiceService.getInvoices({ params });
        this.invoices = response.data?.data ?? [];
      } catch {
        this.invoices = [];
      } finally {
        this.loading = false;
      }
    },

    // Al seleccionar una factura, obtener detalles completos (con email, address, products)
    async onChangeSelect() {
      if (!this.userBusinessInvoiceId) return;
      this.loadingFull = true;
      try {
        const res = await invoiceService.getInvoceId(
          this.userBusinessInvoiceId
        );
        const fullInvoice = res.data?.data ?? res.data;
        this.$emit("onChangeSelect", { invoice: fullInvoice });
      } catch {
        // Fallback al objeto del listado
        const fallback = this.invoices.find(
          i => i.id === this.userBusinessInvoiceId
        );
        this.$emit("onChangeSelect", { invoice: fallback });
      } finally {
        this.loadingFull = false;
      }
    }
  },
  mounted() {
    this.fetchInvoices();
  }
};
</script>

<style lang="sass" scoped></style>
